import PropTypes from 'prop-types';
import React from 'react';

import { WHITE } from '@wetransfer/transfer/constant/colors';

const Link = ({ color, className }) => (
  <svg className={className} viewBox="0 0 96 96">
    <path
      fill={color}
      d="M88.7001 7.3c-4.4-4.4-10.2-6.8-16.4-6.8-6.2 0-12 2.4-16.4 6.8l-10.7 10.6c-2.1 2.1-2.1 5.4 0 7.4 2.1 2.1 5.4 2.1 7.4 0l10.6-10.6c4.8-4.8 13.2-4.8 17.9 0 4.9 4.9 4.9 13 0 17.9l-17.5 17.8c-4.8 4.8-13.2 4.8-17.9 0-2.1-2.1-5.4-2.1-7.4 0-2.1 2.1-2.1 5.4 0 7.4 4.4 4.4 10.2 6.8 16.4 6.8 6.2 0 12-2.4 16.4-6.8l17.7-17.7c4.4-4.4 6.8-10.2 6.8-16.4 0-6.2-2.5-12-6.9-16.4z"
    />
    <path
      fill={color}
      d="M43.3001 70.6l-10.6 10.7c-4.9 4.9-13 4.9-17.9 0-4.9-4.9-4.9-13 0-17.9l17.7-17.7c4.9-4.9 13-4.9 17.9 0 2.1 2.1 5.4 2.1 7.4 0 2.1-2.1 2.1-5.4 0-7.4-9.1-9.1-23.8-9.1-32.8 0l-17.7 17.6c-9.1 9.1-9.1 23.8 0 32.8 4.5 4.5 10.5 6.8 16.4 6.8 5.9 0 11.9-2.3 16.4-6.8l10.6-10.6c2.1-2.1 2.1-5.4 0-7.4-2-2.1-5.3-2.1-7.4-.1z"
    />
  </svg>
);

Link.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Link.defaultProps = {
  color: WHITE,
};

export default Link;
